import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuthV2 } from "@/lib/authv2/store";
import { homePathFor } from "@/lib/authv2/navigation";

/**
 * `/home` — điểm hạ cánh sau đăng nhập / mở app. Nằm TRONG khung `/_app` nên
 * lúc chạy tới đây hồ sơ nhân sự đã nạp xong (khung tự chặn khi chưa có), và
 * chỉ việc chuyển tiếp theo `homePathFor`.
 */
export const Route = createFileRoute("/_app/home")({
  component: HomeRedirect,
});

function HomeRedirect() {
  const staff = useAuthV2((s) => s.currentStaff);
  const target = homePathFor(staff);
  return "search" in target ? <Navigate to={target.to} search={target.search} replace /> : <Navigate to={target.to} replace />;
}
